import './Footer.scss';

export const Footer = () => {
  return (
    <footer className="footer">
      “Виконано в
      <a className="footer-link" href="https://prometheus.org.ua/">
        Prometheus
      </a>
      © 2022”
    </footer>
  );
};
